import React from 'react';
import { string, object, func } from 'prop-types';

import ArrowIcon from './images/arrow.svg';

import styles from './Arrows.scss';

const Arrow = ArrowType => {
  function Arrow({ style, className, onClick }) {
    return (
      <ArrowType
        style={style}
        className={`${styles.root} ${className}`}
        onClick={onClick}
      />
    );
  }

  Arrow.propTypes = {
    className: string,
    style: object,
    onClick: func,
  };

  Arrow.defaultProps = {
    className: '',
    style: {},
    onClick: () => {},
  };

  return Arrow;
};

export const PrevArrow = Arrow(props => (
  <div onClick={props.onClick} className={props.className} style={props.style}>
    <img src={ArrowIcon} width={8} />
  </div>
));

export const NextArrow = Arrow(props => (
  <div onClick={props.onClick} className={props.className} style={props.style}>
    <img src={ArrowIcon} width={8} />
  </div>
));



// WEBPACK FOOTER //
// ./app/components/Arrows/Arrows.jsx